import React, { useEffect } from "react";
import { useState, useRef } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Box,
  Alert,
  Snackbar,
} from "@mui/material";

import changePassword from "../api/user/changePassword";

const ChangePasswordDialog = ({ open, handleChangePasswordClose }) => {


  // Declare state variables for each field

  /* ChangePassword */

  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordNotMatch, setPasswordNotMatch] = useState("");

  /* Global */
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);
  const [alertHidden, setAlertHidden] = useState(true);
  const [snakeOpen, setSnakeOpen] = useState(false);
  const [snakeMsg, setSnakeMsg] = useState("");
  useEffect(() => {
    if (password === confirmPassword) {
      setPasswordNotMatch(false);
    } else {
      setPasswordNotMatch(true);
    }
  }, [password, confirmPassword]);

  const handleChangePasswordButtonClick = async () => {
    if (
      oldPassword !== "" &&
      (password !== "") & (confirmPassword !== "") &&
      !passwordNotMatch
    ) {
      setLoading(true);
      try {
        const responseData = await changePassword(oldPassword,password);
        if (responseData.code === "000") {
          setSnakeMsg("密碼變更成功。");
          setSnakeOpen(true);
          setAlertHidden(true);
          handleChangePasswordClose()
        } else {
          setError("密碼變更失敗");
          setAlertHidden(false);
        }
      } catch (err) {
        console.error(err.message)
      } finally {
        setLoading(false);
      }
    } else {
      setError("");
      setAlertHidden(false);
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          setOldPassword("")
          setPassword("");
    setConfirmPassword("");
    handleChangePasswordClose()
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold" }}>變更密碼</DialogTitle>
        <DialogContent>
          <Box>
            <TextField
              color="secondary"
              margin="dense"
              id="oldPassword"
              type="password"
              label="舊密碼"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              fullWidth
            />
          </Box>

          <TextField
            color="secondary"
            margin="dense"
            id="password"
            label="密碼"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
          <TextField
            color="secondary"
            margin="dense"
            id="confirmPassword"
            label="確認密碼"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={passwordNotMatch} // Here we set the error state of TextField
            helperText={passwordNotMatch ? "密碼不相同" : ""} // Here we set the helper text when there is an error
          />
          <Alert
            sx={
              alertHidden
                ? { display: { xs: "none", md: "block" } }
                : { display: {} }
            }
            icon={false}
            severity="warning"
          >
            {error}
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            sx={{ color: "#004B97", border: "1px solid #ACD6FF" }}
            onClick={handleChangePasswordClose}
          >
            取消
          </Button>
          <Box style={{ flexGrow: 2 }}> </Box>
          <Button
            variant="contained"
            sx={{ fontWeight: "bold", border: "1px solid #555555" }}
            color="primary"
            style={{ flexGrow: 1 }}
            onClick={handleChangePasswordButtonClick}
            disabled={loading}
          >
            {loading ? "處理中..." : "確認"}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar   severity="success" open={snakeOpen} autoHideDuration={5000} onClose={(event, reason) => {
        if (reason === 'clickaway') {
          return;
        }

        setSnakeOpen(false);
      }}
        message={snakeMsg} ></Snackbar>
    </div>
  );
};

export default ChangePasswordDialog;
